module.exports = new __parcel__URL__("dash.ebcd855c.png").toString();